module.exports = __webpack_public_path__ + "static/media/1.f0100586.jpg";